module.exports = __webpack_public_path__ + "img/102.defeb8dc.jpg";